/*
 * Standard colours to be used with CSS color properties
 */

export const WHITE = '#FFFFFF';

export const GREY = '#243744';
export const LIGHT_GREY = '#395364';
export const BLACK_GREY = '#151D24';
export const DARK_GREY = '#142937';
export const BLUE = '#00ABDA';

export const DARK_RED = '#A51C30';
export const RED = '#E52030';
export const DARK_AMBER = '#C29200';
export const AMBER = '#FFC000';
export const DARK_GREEN = '#00AE4E';
export const GREEN = '#88BD39';

export const TEXT = WHITE;
export const ERROR = RED;
export const HIGHLIGHT = BLUE;
export const BACKGROUND = DARK_GREY;
export const CONTAINER = LIGHT_GREY;
export const PLACEHOLDER = '#94A2AB';

export const TECHNOLOGY_2G_MAIN = '#4DB6C9';
export const TECHNOLOGY_2G_POOR = '#142937';
export const TECHNOLOGY_2G_WEAK = '#98CACD';
export const TECHNOLOGY_2G_OK = '#79C1CB';
export const TECHNOLOGY_2G_STRONG = '#4DB6C9';

export const TECHNOLOGY_3G_MAIN = '#6076BA';
export const TECHNOLOGY_3G_POOR = '#A5CEEF';
export const TECHNOLOGY_3G_WEAK = '#8CB7E3';
export const TECHNOLOGY_3G_OK = '#72A0D5';
export const TECHNOLOGY_3G_STRONG = '#6076BA';

export const TECHNOLOGY_4G_MAIN = '#BA6897';
export const TECHNOLOGY_4G_POOR = '#BDA5BC';
export const TECHNOLOGY_4G_WEAK = '#BC92B0';
export const TECHNOLOGY_4G_OK = '#BB7EA4';
export const TECHNOLOGY_4G_STRONG = '#BA6897';

export const TECHNOLOGY_5G_MAIN = '#AD62E5';
export const TECHNOLOGY_5G_POOR = '#E8D4F7';
export const TECHNOLOGY_5G_WEAK = '#B497C7';
export const TECHNOLOGY_5G_OK = '#8F6DAD';
export const TECHNOLOGY_5G_STRONG = '#AD62E5';
